import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BRAND } from '../data/content';
import { WhatsappIcon } from './icons/LineIcons';
export function WhatsappFloat() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-347" data-mp="1ypite32apwx2">
      {visible ? <motion.a initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} href={BRAND.whatsappUrl} target="_blank" rel="noopener noreferrer" aria-label="Hablar por WhatsApp" className="group fixed bottom-5 right-5 z-40 flex items-center gap-3 rounded-full border border-gold/40 bg-graphite/95 px-4 py-3 text-white shadow-[0_20px_50px_-20px_rgba(0,0,0,0.9)] backdrop-blur transition-all duration-300 hover:border-gold hover:shadow-[0_0_36px_-10px_rgba(245,197,24,0.8)] sm:bottom-8 sm:right-8" data-id="element-348" data-mp="1yqkfr3ori5u3">
          <WhatsappIcon className="h-5 w-5 text-gold" data-id="element-349" data-mp="2iy9zezlmnp71" />
          <span className="hidden font-sans text-xs font-semibold uppercase tracking-[0.14em] sm:inline" data-id="element-350" data-mp="2nxuxl7sz3tip">
            WhatsApp
          </span>
        </motion.a> : null}
    </AnimatePresence>;
}